import type {ReactNode} from 'react'
import {maybe} from '@freckle/maybe'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {Sidebar} from '@freckle/school/ts/common/components/dashboard/sidebar'
import {TopBar} from '@freckle/school/ts/common/components/dashboard/top-bar'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'

type Props = {
  children?: ReactNode
  schools: Array<SchoolAttrs>
  schoolAdmin: SchoolAdminAttrs
  tabId: string
}

export const Dashboard = ({schools, schoolAdmin, tabId, children}: Props) => (
  <div className="container-fluid">
    <div className="row">
      <Sidebar
        tabId={tabId}
        countryCode={maybe(
          () => null,
          school => school.countryCode,
          schools[0],
        )}
      />

      <div id="content">
        <TopBar schoolAdmin={schoolAdmin} />

        <div className="row main-content">
          <div className="col-12">{children}</div>
        </div>
      </div>
    </div>
  </div>
)
